"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FEATURE_NAME = void 0;
var _features = require("../../loaders/features/features");
const FEATURE_NAME = exports.FEATURE_NAME = _features.FEATURE_NAMES.pageViewEvent;